import Icon from './Icon';
import outlineIcons from './icons/outline/index';
import solidIcons from './icons/solid/index';

export default Icon;
export { outlineIcons, solidIcons };
